import { findClosestTopCity } from "./find-closest-top-city";

export async function fetchTopCities(query: string) {
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_SEARCH_ENDPOINT}/here/geocode/${query}`,
  );
  const location = await res.json();
  const closestTopCity = findClosestTopCity(
    location[0].position.lat,
    location[0].position.lng,
  );

  return closestTopCity;
}
